import firebase from 'firebase/app';
import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';

@Injectable()

export class ChangeAssignedBrokerService {
    public addiApplicant: any;
    constructor(
        public db: AngularFirestore,
        public afAuth:AngularFireAuth
    ) { 
        this.addiApplicant = [];
    }

    changeAssignedBroker(request){
        console.log(request);
        //let thiss = this;
        //const sdfForm = this.db.collection('/SDF_form');
        const usersData = this.db.collection('/users_data');
        if(request.SDF_form_document_id == "" || request.SDF_form_document_id == null || request.SDF_form_document_id == undefined){}else{
            //let timestamp = new Date().getTime();
            this.getAllContactBySDFID(request.SDF_form_document_id).subscribe((contacts)=>{
                console.log(contacts);
                if(contacts.length > 0){
                    Object.keys(contacts).forEach(function(key) {
                        usersData.doc(contacts[key].document_id).update({
                            reference_broker: request.reference_broker
                        });
                    });
                }
            });
        }
    }

    getAllContactBySDFID(SDF_form_document_id){
        return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id ).where('deleted','==',0 )).valueChanges ();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/change-assigned-brokerService.ts